exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflow-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n", ""]);

// exports
